<template>
    <BlockConfig title="Tabella misure"
    :valid="valid"
    @handleSave="handleSave"
    @restore="restore">
    <v-form v-model="valid">
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="nome prova*"
                :rules="[rules.mandatory]" 
                v-model="config_data.title"
            ></v-text-field>
            <!--v-text-field dense outlined class="ma-2" required :rules="[rules.mandatory]" v-model="config_data.capacity" label="valore della prova (% della portata massima)"></v-text-field>-->
            <v-text-field dense outlined 
                class="ml-2" 
                :rules="[rules.mandatory]" 
                v-model="config_data.min_readings" 
                label="nr. misure*">
            </v-text-field>
        </div>
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="traduzione inglese"
                v-model="config_data.translation"
            ></v-text-field>
        </div>
        <div>
            <v-label>etichette tabella<span class="caption"> - (ordine fisso)</span></v-label>
            <div class="d-flex mt-2">
                <v-text-field dense outlined label="punto zero" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.zero"></v-text-field>
                <v-text-field dense outlined label="pesata" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.reading"></v-text-field>
                <!--
                    <v-text-field dense outlined label="differenza" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers[2]"></v-text-field>
                    <v-text-field dense outlined label="differenza dalla media" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers[3]"></v-text-field>
                    <v-text-field dense outlined label="quadrato della differenza" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers[4]"></v-text-field>
                -->
            </div>
        </div>
    </v-form>
    </BlockConfig>
</template>
<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins: [ConfigMixin],
    // props: ["data"],
    data(){
        return{
            // rules: f_rules,
            // valid: false,
            o_data: {
                title: this.data.block.label,
                translation: "",
                capacity:0,
                min_readings:10,
                headers: {
                   'count': 'n',
                   'zero': 'punto zero', 'reading': 'lettura'
                },
            },
        }
    },
    
}
</script>
